export const NOTIFICATION_DURATION = 1000;
export const ERROR_NOTIFICATION_DURATION = 3000;
